module.exports = __webpack_public_path__ + "static/Zoundream-1537dadc68bef4c566daf0d5a64760f3.png";